import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { updateParties, search } from '../../../state/actions';
import { StateType } from '../../../../state/state.types';

const mapState = ({ queryParams }: StateType) => ({
  parties: queryParams.parties,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onUpdateParties(parties: {
    plaintiff?: { name?: string; type?: string } | null;
    defendant?: { name?: string; type?: string } | null;
  }) {
    dispatch(updateParties(parties));
    dispatch(search({ reason: 'faceted' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
